import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['apiKeyGenerated', 'apiDocBanner', 'apiDocButton'] as const;

export const apiEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
